/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useQuery } from '@apollo/client';

export const CATEGORIES_TOP = gql`
  query getAllCategories {
    categoriesTop {
      name
      identifier
      childCategories {
        name
        id
        identifier
      }
    }
  }
`;
export const useCategoriesTop = () => {
  const { loading, error, data } = useQuery(CATEGORIES_TOP);
  return { loading, error, data };
};
